import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Highcharts from 'highcharts';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { withRouter } from 'react-router-dom';

import BCLLoading from '../../../common/Loading/BCLLoading';
import InsightsSHComparison from './InsightsSHComparison';
import { DASHBOARD_SURVEY_PATH } from '../../../../constants/paths';
import BCLHighchart from '../../../common/Highchart/BCLHighchart';
import { HOME_SURVEY, INSIGHTS_PAGES, PAGE_EVENT_NAMES } from '../../../../constants/common';
import { trackEvent } from '../../../../helpers/analyticsHelper';

class InsightsSimilarHomes extends Component {

  componentWillMount() {
    Highcharts.wrap(Highcharts.Axis.prototype, 'getLinePath', function(p, lineWidth) {
      let linePath = p.call(this, lineWidth);

      if (this.options.arrowOnEnd) {
        const arrowFactor = 10;
        const delta = 0.35;
        let x;
        let y;
        let arrowPath;
        let newPath;

        x = linePath[4];
        y = linePath[5];

        arrowPath = [
          'L', x - delta * arrowFactor, y - delta * arrowFactor,
          'L', x, y,
          'L', x - delta * arrowFactor, y + delta * arrowFactor,
          'L', x, y];

        newPath = linePath.concat(arrowPath);
        return newPath;
      }

      return linePath;
    });
  }

  goToSurvey(questionId) {
    if (questionId) {
      this.props.setQueryParams({
        'questionId': questionId
      });
    }
    this.props.history.push(DASHBOARD_SURVEY_PATH);
    trackEvent(this.props.userId, PAGE_EVENT_NAMES.INSIGHTS, {
      btnClicked : HOME_SURVEY,
      tab : INSIGHTS_PAGES.SIMILAR_HOMES
  })
  }

  render() {
    const { insightsSHData, changeDataToShowOffset, translations, applianceList, selectedAppliance, enableApplianceSHC, configColors } = this.props;

    return(
      <Paper className="insights-inner-container">
        {insightsSHData.isSHChartLoading ? <BCLLoading /> : ''}

        <div className="current-billing-cycle">
          <Typography classes={{body1: 'current-billing-cycle-text'}}>{insightsSHData.currentBillingCycleInfo}</Typography>
        </div>

        <div className={"category-header" + (enableApplianceSHC ? " shc-appliance" : "")}>
          <Typography classes={{body1: 'current-category-text'}}>{translations["SIMILAR_HOMES.HEADING"]}</Typography>
        </div>
        {enableApplianceSHC && applianceList && selectedAppliance && (
          <Container className="shc-appliance-list-container">
            <Tabs variant="scrollable" scrollButtons="on" className="shc-appliance-list" classes={{scrollButtons: "shc-appliance-arrows", scroller: "shc-scroller", indicator: "shc-indicator"}} 
              value={selectedAppliance} >
              {applianceList.map(appliance => (
                <Tab label={appliance.name} className={(selectedAppliance === appliance.id ? 'active' : '') + " shc-appliance-tab"} key={appliance.id} 
                  value={appliance.id} onClick={() => this.props.onSHCRecoChange(appliance.id)} />
              ))}
            </Tabs>
          </Container>
        )}

        <div className="insights-content">
          {insightsSHData.dataNotAvailableText ? <div className="shc-data-not-available">{insightsSHData.dataNotAvailableText}</div> : '' }
          {insightsSHData.dataEmptyText ? <div className="shc-data-not-available">{insightsSHData.dataEmptyText}</div> : '' }
          <BCLHighchart
              options={insightsSHData.options}
              immutable={true}
          />
          <div className="chart-footer">{translations["SIMILAR_HOMES.CHART.FOOTER.TEXT"]}</div>
          <div className="insights-arrow arrow-left" onClick={() => insightsSHData.insightsDataLeftArrowDisabled ? null : changeDataToShowOffset(1)} disabled={insightsSHData.insightsDataLeftArrowDisabled} />
          <div className="insights-arrow arrow-right" onClick={() => insightsSHData.insightsDataRightArrowDisabled ? null : changeDataToShowOffset(-1)} disabled={insightsSHData.insightsDataRightArrowDisabled} />
          {insightsSHData.showDisclaimerMissingInterval && <div className="disclaimer-msg">{translations["DISCLAIMER_ICONS.SHC.ICON1"]} {translations["SIMILAR_HOMES.DISCLAIMER_MSG.MISSING_INTERVAL"]}</div> }
          {insightsSHData.showDisclaimerApplianceMissing && <div className="disclaimer-msg">{translations["DISCLAIMER_ICONS.SHC.ICON2"]} {translations["SIMILAR_HOMES.DISCLAIMER_MSG.APPLIANCE_MISSING"]}</div> }
          {insightsSHData.apiErrorMessage && (
            <Typography component="p" className="api-error-message insights-shc-error">{insightsSHData.apiErrorMessage}</Typography>
          )}
        </div>
        {!insightsSHData.dataNotAvailableText && insightsSHData.shcData && insightsSHData.shcData.length ?
          <Container className="shc-comparison-widget">
            <div className="arrow-up"></div>
            <InsightsSHComparison shcData={insightsSHData.shcData} goToSurvey={(questionId) => this.goToSurvey(questionId)} translations={translations} configColors={configColors}/>
          </Container>
        : ''}
      </Paper>
    );
  }
}

export default withRouter(InsightsSimilarHomes);
